import React, { useState, useEffect, useRef } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, CircularProgress } from '@mui/material';

const CompanyIssuerEditModal = ({ open, onClose, issuer, onSave }) => {
    const [formData, setFormData] = useState(issuer || {});
    const [loading, setLoading] = useState(false);
    const originalDataRef = useRef(issuer);

    useEffect(() => {
        setFormData(issuer || {});
        originalDataRef.current = issuer;
    }, [issuer]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async () => {
        setLoading(true);

        const updatedData = { IssuerID: formData.IssuerID };
        for (const key in formData) {
            if (formData[key] !== originalDataRef.current[key]) {
                updatedData[key] = formData[key];
            }
        }
        await onSave(updatedData);
        setLoading(false);
        onClose();
    };

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>Edit Issuer</DialogTitle>
            <DialogContent>
                <TextField
                    label="Issuer Name"
                    name="IssuerName"
                    value={formData.IssuerName || ''}
                    onChange={handleChange}
                    fullWidth
                    margin="normal"
                />
                <TextField
                    label="Representative First Name"
                    name="IssuerRepFirstName"
                    value={formData.IssuerRepFirstName || ''}
                    onChange={handleChange}
                    fullWidth
                    margin="normal"
                />
                <TextField
                    label="Representative Last Name"
                    name="IssuerRepLastName"
                    value={formData.IssuerRepLastName || ''}
                    onChange={handleChange}
                    fullWidth
                    margin="normal"
                />
                <TextField
                    label="Email ID"
                    name="IssuerRepEmailID"
                    value={formData.IssuerRepEmailID || ''}
                    onChange={handleChange}
                    InputProps={{
                        readOnly: true,
                    }}
                    fullWidth
                    margin="normal"
                />
                <TextField
                    label="Phone Number"
                    name="IssuerRepPhoneNumber"
                    value={formData.IssuerRepPhoneNumber || ''}
                    onChange={handleChange}
                    fullWidth
                    margin="normal"
                />
                <TextField
                    label="Website"
                    name="IssuerWebsite"
                    value={formData.IssuerWebsite || ''}
                    onChange={handleChange}
                    fullWidth
                    margin="normal"
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} disabled={loading}>Cancel</Button>
                <Button onClick={handleSubmit} color="primary" disabled={loading}>
                    {loading ? (
                        <>
                            <CircularProgress size={20} style={{ marginRight: 8 }} color="inherit" />
                            Updating...
                        </>
                    ) : (
                        "Update"
                    )}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default CompanyIssuerEditModal;